// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watermark{z-index:3;position:absolute;bottom:10px;left:10px;pointer-events:none;width:200px;height:auto;-webkit-filter:drop-shadow(0 0 6px rgba(0,0,0,.2));filter:drop-shadow(0 0 6px rgba(0,0,0,.2))}@media (max-device-width:900px){.watermark{display:none}}@media (max-width:1600px){.watermark{display:none}}", ""]);
// Exports
module.exports = exports;
